import { GreenroomState } from '../types/types';

export const selectSrtStreams = (state: GreenroomState) => {
	const { srtStreams, onsiteLocations } = state.VideoReducer;
	const onsiteSrtIds = new Set(onsiteLocations.map((location) => location.srtId));
	// split srt streams into standalone and those associated with onsite locations
	return {
		standaloneSrtStreams: srtStreams.filter((stream) => !onsiteSrtIds.has(stream.id)),
		onsiteSrtStreams: srtStreams.filter((stream) => onsiteSrtIds.has(stream.id)),
	};
};

export const selectLivekitIngresses = (state: GreenroomState) => {
	const { livekitIngresses } = state.LivekitReducer;
	// split ingresses into standalone and those associated with onsite locations via locationId
	return {
		standaloneIngresses: livekitIngresses.filter((ingress) => !ingress.locationId),
		onsiteIngresses: livekitIngresses.filter((ingress) => !!ingress.locationId),
	};
};
